import blog_slider from "./blog_slider";
import blog_sorting from "./blog_sorting";

export default function blog() {
    blog_slider();
    blog_sorting();

}
